export const appPlusIcon = {
    data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 11V4H11V11H4V13H11V20H13V13H20V11H13Z" fill="currentColor"/></svg>`,
    name: 'plus' as const
};